import { InputAdornment, TextField } from '@material-ui/core'
import { useStyles } from './styles'

const CurrencyField = ({ className = '', symbol = 'R$', label = '', value = '0,00', onChange, min = 0.0, max = 9999.99 }) => {
  const styles = useStyles()

  const handleChange = (event) => {
    const { value } = event.target
    const numericValue = value.replace(/[^0-9]/g, '')
    let decimalValue = (Number(numericValue) / 100).toFixed(2)

    if (min !== undefined && Number(decimalValue) < min) {
      decimalValue = min.toFixed(2)
    }
    if (max !== undefined && Number(decimalValue) > max) {
      decimalValue = max.toFixed(2)
    }

    onChange(decimalValue)
  }

  const formatCurrency = (value) => {
    if (!value) return '0,00'
    const [integer, decimal] = value.split('.')
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return `${formattedInteger},${decimal}`
  }

  return (
    <TextField
      className={`${styles.root} ${className}`}
      label={label}
      value={formatCurrency(value)}
      onChange={handleChange}
      InputProps={{
        startAdornment: <InputAdornment position='start'>{symbol}</InputAdornment>,
      }}
      variant='filled'
    />
  )
}

export default CurrencyField
